<template>
  <div class="task">
    <div class="meta-section">
      <h3>Details</h3>
      <div class="select-container select-container--full-width">
        <label for="type">Type</label>
        <select :disabled="!isActive" id="type" v-model="task.type">
          <option value="">Choose a Type</option>
          <option v-for="type in typeList" v-bind:key="type.id" :value="type.id">{{ type.name }}</option>
        </select>
        <!-- prettier-ignore -->
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" fill="#999" /></svg>
      </div>
      <!-- need to consider multiple sites for linkbuilding later -->
      <div class="select-container select-container--full-width">
        <label for="site">Site</label>
        <select :disabled="!isActive" id="site" v-model="task.content.siteIds[0]">
          <option value="">Choose a Site</option>
          <option v-for="site in siteList" v-bind:key="site.id" :value="site.id">{{ site.name }}</option>
        </select>
        <!-- prettier-ignore -->
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" fill="#999" /></svg>
      </div>
      <div class="select-container select-container--full-width">
        <label for="market">Market</label>
        <select :disabled="!isActive" id="market" v-model="task.marketId">
          <option value="">Choose a Market</option>
          <option v-for="market in marketList" v-bind:key="market.id" :value="market.id">{{ market.name }}</option>
        </select>
        <!-- prettier-ignore -->
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" fill="#999" /></svg>
      </div>
      <div class="select-container select-container--full-width" v-if="task.type === 'review'">
        <label for="brand">Brand</label>
        <select :disabled="!isActive" id="brand" v-model="task.content.brandId">
          <option value="">Choose a Brand</option>
          <option v-for="brand in brands" v-bind:key="brand.slug" :value="brand.slug">{{ brand.name }}</option>
        </select>
        <!-- prettier-ignore -->
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" fill="#999" /></svg>
      </div>
      <div class="select-container select-container--full-width" v-if="task.type === 'linkbuilding'">
        <label for="orderedBy">Ordered By</label>
        <select :disabled="!isActive" id="orderedBy" v-model="task.orderedBy">
          <option value="">Choose a Person</option>
          <option v-for="orderedBy in linkBuilderAdmins" v-bind:key="orderedBy.id" :value="orderedBy.id">{{ orderedBy.name }}</option>
        </select>
        <!-- prettier-ignore -->
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" fill="#999" /></svg>
      </div>
      <div class="input-container" v-if="task.type === 'seo'">
        <label for="keyword">Keyword</label>
        <input :disabled="!isActive" class="input" id="keyword" v-model="task.content.keyword" />
      </div>
      <div class="input-container input-container--own-row">
        <label for="requiredWordCountMin">Required Word Count Min</label>
        <input :disabled="!isActive" class="input" id="requiredWordCountMin" v-model.number="task.wordCountMin" />
      </div>
      <div class="input-container input-container--own-row">
        <label for="requiredWordCountMax">Required Word Count Max</label>
        <input :disabled="!isActive" class="input" id="requiredWordCountMax" v-model.number="task.wordCountMax" />
      </div>
      <div v-if="isNew" class="input-container input-container--full-width">
        <label>Special Deadline</label>
        <datetime class="input" type="datetime" v-model="taskDeadline"></datetime>
      </div>
      <div class="select-container select-container--full-width" v-if="user.data.firestore.isAdmin">
        <label for="type">Freelancer</label>
        <select id="type" v-model="task.claimedBy">
          <option value="">Choose a Freelancer</option>
          <option v-for="freelancer in freelancers" v-bind:key="freelancer.id" :value="freelancer.id">{{ freelancer.content.name }}</option>
        </select>
        <!-- prettier-ignore -->
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" fill="#999" /></svg>
      </div>

      <template v-if="displayCopyscapeScore">
        <template v-if="task.copyscapeScore === '0'">
          <div class="copyscape">
            <!-- prettier-ignore -->
            <svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 24 24" width="18"><path d="M0 0h24v24H0V0zm0 0h24v24H0V0z" fill="none"/><path fill="#4adb91" d="M16.59 7.58L10 14.17l-3.59-3.58L5 12l5 5 8-8zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/></svg>
            <span>Copyscape passed</span>
          </div>
        </template>
        <template v-else>
          <a href="https://www.copyscape.com/login.php" target="_blank" class="copyscape">
            <!-- prettier-ignore -->
            <svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 24 24" width="18"><path d="M0 0h24v24H0z" fill="none"/><path fill="#de7d7d" d="M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/></svg>
            <span>Copyscape failed - test manually</span>
            <!-- prettier-ignore -->
            <svg class="copyscape-link-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" fill="#999"></path></svg>
          </a>
        </template>
      </template>
    </div>

    <div class="notes-section">
      <h3>Task Notes</h3>
      <div class="textarea-container">
        <label for="notesFreelancers">Task Description</label>
        <textarea :disabled="!isActive" class="textarea" id="notesFreelancers" rows="5" v-model="task.notesFreelancers"></textarea>
      </div>
      <div class="textarea-container" v-if="user.data.firestore.isAdmin">
        <label for="notesInternal">Internal Notes</label>
        <textarea :disabled="!isActive" class="textarea" id="notesInternal" rows="5" v-model="task.notesInternal"></textarea>
      </div>
    </div>

    <div class="template-section">
      <h3>Task Template</h3>
      <div class="textarea-container" v-if="user.data.firestore.isAdmin && isNew">
        <FileUpload @uploaded="saveTaskTemplate"> </FileUpload>
      </div>
      <div class="textarea-container" v-if="task.templateUrl && !isNew">
        <a class="template-link" :disabled="!isActive" id="templateUrl" rows="5" :href="task.templateUrl">Download Template</a>
      </div>
      <div class="textarea-container" v-if="!task.templateUrl && this.$route.name != 'new'">
        <span class="missing-link">No template URL</span>
      </div>
    </div>

    <template v-if="task.type === 'chatterbox'">
      <Chatterbox :task="task"></Chatterbox>
    </template>
    <template v-else-if="task.type === 'linkbuilding'">
      <LinkBuilding :task="task"></LinkBuilding>
    </template>
    <template v-else-if="task.type === 'review'">
      <Review :task="task"></Review>
    </template>
    <template v-else-if="task.type === 'seo'">
      <SEO :task="task"></SEO>
    </template>
    <template v-else-if="task.type === 'translation'">
      <Translation :task="task"></Translation>
    </template>

    <div v-if="!isNew" class="keyword-wordcount">
      <KeywordDensity :task="task"></KeywordDensity>
      <div class="wordcount">
        <span>Word Count: {{ task.wordCount }} (save to update)</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { Datetime } from 'vue-datetime'
import moment from 'moment'
import Chatterbox from '@/components/task/chatterbox'
import LinkBuilding from '@/components/task/linkbuilding'
import Review from '@/components/task/review'
import SEO from '@/components/task/seo'
import Translation from '@/components/task/translation'
import KeywordDensity from '@/components/keyword'
import FileUpload from '@/components/fileUpload'

export default {
  props: {
    task: Object,
  },
  inheritAttrs: false,
  watch: {
    'task.claimedBy': function(newVal) {
      if (newVal) {
        this.task.deadlineAt = moment()
          .add(5, 'days')
          .toISOString()
        this.task.status = 'claimed'
        this.task.claimedAt = moment().toISOString()
        return
      }
      this.task.status = 'available'
      delete this.task.deadlineAt
      delete this.task.claimedAt
    },
  },
  computed: {
    ...mapGetters(['typeList', 'statusList', 'marketList', 'siteList', 'brands', 'linkBuilderAdmins', 'user', 'freelancers']),
    isActive() {
      const isAdmin = this.user.data.firestore.isAdmin
      const status = this.task.status

      if (!isAdmin) {
        return status == 'available' || status == 'claimed' || status == 'revision-needed' ? true : false
      } else {
        return true
      }
    },
    displayStatusDropdown() {
      if (this.user.data.firestore.isAdmin && this.task.status !== 'available') {
        return true
      }
      return false
    },
    displayCopyscapeScore() {
      if (this.user.data.firestore.isAdmin && this.task.copyscapeScore !== '') {
        return true
      }
      return false
    },
    isNew() {
      return this.$route.name == 'new' ? true : false
    },
    taskDeadline: {
      cache: false,
      get: function() {
        if (this.task.deadlineAt === '0001-01-01T00:00:00.000Z' || this.task.deadlineAt === '0001-01-01T00:00:00Z') return null
        return this.task.deadlineAt
      },
      set: function(newDateTime) {
        if (newDateTime) {
          this.task.deadlineAt = newDateTime
        }
      },
    },
  },
  methods: {
    ...mapActions(['setTaskDeadline']),
    saveTaskTemplate(url) {
      this.task.templateUrl = url
    },
  },
  components: {
    Chatterbox,
    LinkBuilding,
    Review,
    SEO,
    Translation,
    KeywordDensity,
    FileUpload,
    Datetime,
  },
}
</script>

<style lang="scss">
@import '@/assets/shared-styles/checkbox.scss';
@import '@/assets/shared-styles/input.scss';
@import '@/assets/shared-styles/select.scss';
@import '@/assets/shared-styles/sections.scss';
@import '@/assets/shared-styles/textarea.scss';

.task {
  background: white;
}
.keyword-wordcount {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  .wordcount {
    font-size: 0.8125rem;
    text-align: right;
    padding: 2rem;
  }
}

.template-link {
  font-size: 0.75rem;
  color: var(--color-cta);
  text-decoration: none;
}

.template-link {
  color: var(--color-cta-hover);
}

.missing-link {
  font-size: 0.75rem;
  text-decoration: none;
}

.vdatetime-input {
  background: none !important;
  border: none !important;
}
</style>
